import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import type { IStoreFilter } from '../store-filter/store-filter.interface';
import { SdStoreFilterComponent } from '../store-filter/store-filter.component';

import { BrandsEnum } from '@seb/web-design-system/core';

@Component({
  selector: 'sd-store-filter-group',
  templateUrl: './store-filter-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdStoreFilterComponent]
})
export class SdStoreFilterGroupComponent {
  @Input()
  brand: BrandsEnum;

  @Input()
  filters: IStoreFilter[];

  @Output()
  storeFiltered = new EventEmitter<IStoreFilter[]>();

  onFilterChange() {
    this.storeFiltered.emit(this.filters);
  }
}
